import { OptionTypeBase, SelectProps } from 'module/ui/components/atoms/select';
import styled from 'styled-components';
import { GroupedDropdownSelect } from './select';

const StyledGroupedDropdownSelect = styled(GroupedDropdownSelect)`
  padding-top: var(--spacing-05);
`;

const Title = styled.div`
  padding: var(--spacing-05);
  padding-bottom: 0;
  font-weight: var(--font-weight-bold);
  text-transform: capitalize;
`;

interface ContentProps<OptionType extends OptionTypeBase = OptionTypeBase> {
  title?: string | React.ReactNode;
  selectProps?: Omit<SelectProps<OptionType>, 'onChange' | 'value' | 'options'>;
  selected?: OptionType;
  onChange: (values: OptionType) => void;
  options: SelectProps<OptionTypeBase>['options'];
}

export const Content = ({
  title,
  selectProps,
  selected,
  onChange,
  options,
}: ContentProps): React.JSX.Element => {
  return (
    <div data-cy="grouped_criteria.field_selector">
      {title && <Title>{title}</Title>}
      <StyledGroupedDropdownSelect
        {...selectProps}
        onChange={onChange}
        value={selected}
        options={options}
      />
    </div>
  );
};
